import module from 'module';
import './information-bar.less';

const templateUrl = require('./information-bar.template.html');

module.component('informationBar', {
  templateUrl: templateUrl,
  controller: function (informationMessageService) {
    const that = this;

    informationMessageService.toObservable()
      .subscribe(informationMessage => that.message = informationMessage || null);
  }
});